import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  Grid,
  Stack,
  Typography,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import DownloadIcon from '@mui/icons-material/Download';
import { BemsGraph, FemsGraph, MasterGraph } from '../../utility/apiURLS';
import CustomDialog from '../commoncomponents/CustomDialog';
import CustomAgGrid from '../commoncomponents/CustomAgGrid';
import {
  getAuthToken,
  getCreatedBy,
} from "../../utility/tokenUtility";
import CustomAlert from '../userlocationcomponents/CustomAlert';
import CustomSelectInput from '../commoncomponents/CustomSelectInput';
import CustomTooltip from '../commoncomponents/CustomTooltip';
import { format, isValid, parseISO } from 'date-fns';
import RoutineInspectionSignatureGrid from './RoutineInspectionSignatureGrid';
import RoutineInspectionBottomButtonForVendorForm from './RoutineInspectionBottomButtonForVendorForm';
import riRepository from '../../api/repositories/riRepository';
import { routineInspectionCheckFormSubmitForVendor, routineInspectionClearWebForm } from '../../redux/actions/vendor/routineInspectionWebFormActions';
import BottomButtonForVendor from '../vendordashboard/BottomButtonForVendor';
import { statusList } from '../../utility/message';

const RoutineInspectionAttachmentsEditForm = ({ buttonAttributes, page, locationState }) => {

  const navigate = useNavigate();
  const location = useLocation();
  const createdBy = getCreatedBy("createdBy");
  const [rows, setRows] = useState([{
    id: 1,
    file: null,
    documenttitle: '',
    documenttype: '',
    filesize: '',
  }]);
  const webFormData = useSelector((state) => state.routineInspectionVendorWebForm);
  const dispatch = useDispatch();
  const workOrderId = locationState?.workorderId;
  const assetCategroyType = locationState?.serviceType;
  const categoryType = locationState?.categoryType;
  const serviceType = assetCategroyType === "FEMS" ? "fem" : "bem";
  const workOrderNo = webFormData?.respondedDetails?.workOrderNo || "";
  const categoryFieldName = categoryType === "Scheduled" ? "scheduled" : "unscheduled";
  const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
  const token = getAuthToken("id_token");
  const isViewMode = location?.state?.isViewMode;
  const getstatusId = assetCategroyType === "FEMS" ? "femworkorderstatusId" : "bemworkorderstatusId";
  const getStatus = location?.state?.updateWorkorderstatus || location?.state?.[`${getstatusId}`]


  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const attachmentTypeOptions = [
    { id: 1, label: "Before" },
    { id: 2, label: "After" },
    { id: 3, label: "Others" },
  ];

  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [attachmentMandatory, setAttachmentMandatory] = useState('');
  const [sigantureMandatory,setSigantureMandatory] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [gridApi, setGridApi] = useState(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [formSubmitDialog, setFormSubmitDialog] = useState(false);
  const [openAlertDialog, setOpenAlertDialog] = useState();
  const [signatureRows, setSignatureRows] = useState([
    {
      id: 1,
      category: '',
      fileType: '',
      designation: '',
      size: '',
    }
  ]);
  const [signatureDeleteDialog, setSignatureDeleteDialog] = useState(false);
  const [signatureId, setSignatureId] = useState(null);
  const [signatureDialog, setsignatureDialog] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [getByIdSignatures, setGetByIdSignatures] = useState([]);
  const [isSignatureAffected, setIsSignatureAffected] = useState(false);
  const [dropDownValue, setDropDownValue] = useState("");
  const [dropdownError, setDropdownError] = useState(false);
  const [dropDownErrorMessage, setDropDownErrorMessage] = useState("");
  const [openSaveDialog, setOpenSaveDialog] = useState(false);
  const [enableAuthorize, setEnableAuthorize] = useState(true);
  const checkstatus = [4,5,8,9].includes((webFormData?.workderStatus)) ? true : false;


  function AddRowButton(props) {
    const handleClick = () => {
      props.onClick();
    };

    return (

      <Box sx={{ mb: 1 }}>

        <Button color="primary" variant="contained" startIcon={<AddIcon />} onClick={handleClick} >
          Add Row
        </Button>
      </Box>
    );
  }

  const fetchFiles = async () => {

    const checkFemorBem = serviceType === "fem" ? "Fem" : "Bem";
    const checkFieldName = serviceType === "fem" ? "fem" : "bem"

    const getAttachementCategory = categoryType === "Scheduled" ? "GetscheduledAttachmentsList" : "GetunscheduledAttachmentsList";
    try {
      const response = await axios.get(`${checkGraph}/api/RoutineInspection/GetRoutineInspectionattachement/${workOrderId}`, config);
      const fetchedFiles = response.data;

      const gridRows = fetchedFiles.map((file) => {
        const attachmentTypeId = file?.[`${checkFieldName}woattachmenttypeId`] || "";
        const attachmentTypeOption = attachmentTypeOptions.find(option => option?.id === attachmentTypeId);


        setDropDownValue(prev => ({
          ...prev,
          [file?.id]: attachmentTypeOption || {id:3,label:"Others"},
        }));

        return {
          id: file?.id,
          filename: file?.filename,
          filepath: file?.filepath,
          filesize: file?.filesize,
          documenttitle: file?.documenttitle,
          documenttype: file?.documenttitle?.split('.')?.pop()?.toLowerCase(),
          attachmentType: attachmentTypeOption || { id: 3, label: "Others" },
        };
      });
      if (response?.data?.length > 0) {
        setRows(gridRows);
      }
      //   else if (viewmode == true) {
      //     setRows(gridRows);
      //  }
      else {
        const newRow = {
          id: 1,
          documenttitle: '',
          file: '',
          documenttype: "",
          filesize: '',
          attachmenytType:{ id: 3, label: "Others" }
        };
        setDropDownValue((prev) => ({
          ...prev,
          [newRow?.id]: { id: 3, label: "Others" }
        }));        
        setDropDownErrorMessage("");
        setDropdownError(false);
        setRows([newRow]);
      }
    } catch (error) {
      console.error('Error fetching files:', error);
    }


  };

  useEffect(() => {
    fetchFiles();
  }, []);

  const handleDeleteClick = (id) => () => {
    const selectedRow = rows.find(row => row.id === id);
    if (rows.length === 1 && (!selectedRow.documenttype || selectedRow.documenttype === '')) {
      return;
    }
    if (selectedRow && (!selectedRow.documenttype || selectedRow.documenttype === '')) {
      const updatedRows = rows.filter((row) => row.id !== id);
      setRows(updatedRows);
      const updatedSelectedFiles = selectedFiles.filter(file => file.id !== id);
      setSelectedFiles(updatedSelectedFiles);
    } else if (selectedRow) {
      setSelectedId(id);
      setDeleteDialogOpen(true);
    }
  };


  const handleDeleteConfirm = async () => {
    const selectedRow = rows.find(row => row.id === selectedId);
    if (rows.length === 1 && (!selectedRow.documenttype || selectedRow.documenttype === '')) {
      setDeleteDialogOpen(false);
      return;
    }

    if (selectedRow) {
      try {
        if (typeof selectedId === 'string') {
          const response = await axios.delete(
            `${checkGraph}/api/${serviceType}routineinspectattachments/${selectedId}`,
            config
          );

          if (response.status >= 200 && response.status <= 204) {
            const updatedRows = rows.filter((row) => row.id !== selectedId);
            setRows(updatedRows);
            const updatedSelectedFiles = selectedFiles.filter(file => file.id !== selectedId);
            setSelectedFiles(updatedSelectedFiles);
            fetchFiles();
          } else {
            throw new Error('Failed to delete record');
          };
        } else if (typeof selectedId === 'number') {
          const updatedRows = rows.filter((row) => row.id !== selectedId);
          setRows(updatedRows);
          const updatedSelectedFiles = selectedFiles.filter(file => file.id !== selectedId);
          setSelectedFiles(updatedSelectedFiles);
          if (updatedRows.length < 1) {
            fetchFiles();
          };
        };
      } catch (error) {
        console.error('Error deleting attachment:', error);
        setError(true);
        setErrorMessage('Error deleting attachment. Please try again.');
      }
    }
    setDeleteDialogOpen(false);
  };

  const handleDeleteDialogClose = () => {
    setDeleteDialogOpen(false);
  };


  const handleAddRow = () => {
    const id =
      rows.length > 0
        ? Math.max(...rows.map((row) => (isNaN(row.id) ? 0 : Number(row.id)))) + 1
        : 1;
    const newRow = {
      id: id,
      file: "",
      documenttitle: '',
      documenttype: '',
      filesize: '',
      attachmentType: { id: 3, label: "Others" }
    };
    setRows((oldRows) => [...oldRows, newRow]);
    setDropDownValue((prev) => ({
      ...prev,
      [id]: {id:3,label:"Others"},
    }));

    setDropdownError((prev) => ({
      ...prev,
      [id]: false,
    }));

    setDropDownErrorMessage((prev) => ({
      ...prev,
      [id]: "",
    }));
  };


  const handleFileChange = (event, id) => {
    const file = event.target.files[0];
    if (!file) return;
    const fileName = file.name;
    const fileExtension = fileName.split('.').pop().toLowerCase();
    if (file.size > 20 * 1024 * 1024) {
        setError(true);
        setErrorMessage('Error: File size exceeds 20 MB. Please select smaller files.');
        return;
    };

    // Get dropdown value for the row
    const dropdownValue = dropDownValue[id];
    const isAfterOrBefore = dropdownValue?.id === 1 || dropdownValue?.id === 2;
    const allowedFileExtensions = isAfterOrBefore ? ['jpeg', 'jpg', 'png'] : ['doc', 'jpeg', 'jpg', 'png', 'xlsx', 'csv', 'pdf', 'docx'];

    // Check file type validity
    if (!allowedFileExtensions.includes(fileExtension)) {
        setError(true);
        setErrorMessage(isAfterOrBefore
            ? 'Error: Only JPEG, JPG, and PNG files are allowed for this selection.'
            : 'Error: Only DOC, JPEG, JPG, PNG, XLSX, CSV, and PDF files are allowed.'
        );

        // Show attachment type dialog for invalid files on "after" or "before" selections
        if (isAfterOrBefore) {
            // setAttachmentTypeDialog(true);
            setDropDownValue(prev => ({
                ...prev,
                [id]: {id:3,label:"Others"}, // Reset dropdown if invalid file is chosen
            }));
        }
        return;
    }

    let updatedSelectedFiles = [...selectedFiles];
    const fileIndex = updatedSelectedFiles.findIndex((file) => file.id === id);
    if (fileIndex > -1) {
        updatedSelectedFiles[fileIndex] = { id, file };
    } else {
        updatedSelectedFiles.push({ id, file });
    };
    setSelectedFiles(updatedSelectedFiles);

    const updatedRows = rows.map((row) => {
        if (row.id === id) {
            let fileSize;
            if (file.size >= 1024 * 1024) {
                fileSize = (file.size / (1024 * 1024)).toFixed(2) + ' MB';
            } else {
                fileSize = (file.size / 1024).toFixed(2) + ' KB';
            };

            return {
                ...row,
                file,
                documenttitle: fileName,
                documenttype: fileExtension,
                filesize: fileSize,
            };
        };
        return row;
    });

    setRows(updatedRows);
    setAttachmentMandatory(false);
    setHasUnsavedChanges(true);
};

  const handleDownload = async (file) => {
    try {
      const response = await axios.get(`${MasterGraph}/api/FileUpload/DownloadFile/${file.filename}`, {
        ...config,
        responseType: 'blob'
      });

      if (response) {
        const url = URL.createObjectURL(response.data);
        const a = document.createElement('a');
        a.href = url;
        a.download = file.documenttitle || file.filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      }
      else {
        if (file && file instanceof Blob) {
          const url = URL.createObjectURL(file);
          const a = document.createElement('a');
          a.href = url;
          a.download = file.documenttitle || file.filename;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(url);
        } else {
          console.error('Invalid file object:', file);
        };
      };
    } catch (error) {
      console.error('Error downloading file:', error);
    };
  };


  const handleDownloadClick = (event, file) => {
    event.preventDefault();
    handleDownload(file);
  };
  function uuidv4(extension) {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    }) + '.' + extension;
  };

  const uploadFiles = async (formData) => {
    try {
      let storeFileNameArray = [];
      let storeregsitredFilesResponse = [];
      let storefileUploadResponse = [];
      for (let i = 0; i < selectedFiles?.length; i++) {
        const formData = new FormData();
        const extension = selectedFiles[i]?.file?.name.split('.').pop();
        const fileName = uuidv4(extension); // generate a unique id
        formData.append('fileObj', selectedFiles[i]?.file, fileName); // append file with unique id as filename
        storeFileNameArray.push({ id: fileName, filename: `${selectedFiles[i]?.file?.name}`, selectedFileId: selectedFiles[i]?.id });

        try {
          const fileUploadResponse = await axios.post(`${MasterGraph}/api/fileupload`, formData, config);
          storeregsitredFilesResponse.push(fileUploadResponse.data);
          storefileUploadResponse.push(fileUploadResponse.data);
        } catch (error) {
          console.log('Error uploading file:', error.response ? error.response.data : error.message);
        }
      }
      return { storefileUploadResponse, storeFileNameArray };
    } catch (error) {
      console.error('Save error:', error);
      throw error;
    }
  };

  const saveFilesToAttachment = async (payload) => {
    try {
      const response = await axios.post(`${checkGraph}/api/${serviceType}routineinspectattachments`, payload, config);
      if (response.status >= 200 && response.status <= 204) {
        setOpenDialog(true);
      }
      return response.data;
    } catch (error) {
      console.error('Save error:', error);
      throw error;
    };
  };

  const handleSaveClick = async (event) => {
    event.preventDefault();

    const checkFemorBem = serviceType === "fem" ? "Fem" : "Bem";
    if (selectedFiles.length > 0) {
      try {
        const filteredSelectedFiles = selectedFiles.filter(file => rows.some(row => row.id === file.id));
        if (filteredSelectedFiles.length > 0) {
          const { storefileUploadResponse, storeFileNameArray } = await uploadFiles(filteredSelectedFiles);

          if (storefileUploadResponse?.length > 0) {
            let storefileUploadResponseFinal = [];

            for (let i = 0; i < storefileUploadResponse.length; i++) {
              const file = storefileUploadResponse[i];
              const selectedFileId = storeFileNameArray[i];

              const documentTitle = storeFileNameArray.find((item) => item.id === file.fileName)?.filename;
              const documenttype = documentTitle.split('.').pop().toLowerCase();
              if (documentTitle) {
                const rowId = selectedFileId?.selectedFileId || "";
                const attachementTypeValue = dropDownValue[rowId];

                const payload = {
                  filename: file.fileName,
                  filesize: file.fileSize,
                  filepath: "D:/IFAC-X/UploadFolder",
                  documenttitle: documentTitle,
                  [`${serviceType}routineinspectionheaderId`]: workOrderId,
                  createdby: createdBy,
                  documenttype: documenttype,
                  [`${checkFemorBem}woattachmenttypeId`]: attachementTypeValue?.id || ""
                };

                try {
                  const response = await saveFilesToAttachment(payload);
                  setHasUnsavedChanges(false);
                  if (response) {
                    storefileUploadResponseFinal.push(response);
                    fetchFiles();
                  } else {
                    console.log("Error saving file:", file.fileName);
                  }
                } catch (error) {
                  console.log('Error saving file:', error);
                }
              } else {
                console.log("Document Title not found for file:", file.fileName);
              }
            }

            if (storefileUploadResponseFinal?.length > 0 && storefileUploadResponseFinal?.length === storefileUploadResponse?.length) {
              setOpenDialog(true);
            } else {
              console.log("Error in uploading some files");
            }
          } else {
            console.log("No files registered");
          }
        }
      } catch (error) {
        console.log('Error registering files:', error);
      }
    } else {
      console.log("No files selected for upload");
    }
    setFormSubmitDialog(false);
    setOpenSaveDialog(true);
  };


  const handleSaveSignature = (id, data) => {

    // Update the row with the new signature
    const updatedRows = signatureRows.map((row) =>
      row.id === id ? { ...row, ...data, fileSignature: data.file } : row
    );

    setSignatureRows(updatedRows);
    fetchFormData();
    setSigantureMandatory(false);
    setsignatureDialog(false);
  };


  const fetchFormData = async () => {
    try {
      const checkFemorBem = serviceType === "fem" ? "Fem" : "Bem";
      const completionCategoryFieldName = categoryType === "Scheduled" ? "Getscheduled" : "Getunscheduled";
      const id = webFormData?.completionDetails?.completionId;

      const response = await axios.get(`${checkGraph}/api/RoutineInspection/GetRIsignatureList/${workOrderId},1,5000`, config);
      if (response?.data?.length > 0) {
        setGetByIdSignatures(response?.data);
        const rowsData = response.data.map((item) => ({
          id: item?.id,
          name: item?.documenttitle || '',
          designation: item?.designation || '',
          fileType: item?.documenttype || '',
          size: item?.filesize || '',
          date: item?.signaturedate || '',
          filename: item?.filename || '',
        }));

        setSignatureRows(rowsData);
      } else {
        const newRow = {
          id: 1,
          category: '',
          fileType: '',
          designation: '',
          size: '',
        };
        setSignatureRows([newRow]);
      }
    } catch (error) {
      console.log(error);
    };
  };
  useEffect(() => {
    fetchFormData();
  }, [webFormData]);

  const handleSignatureDownload = async (file) => {
    try {

      if (file && (file instanceof Blob || file instanceof File)) {
        const url = URL.createObjectURL(file);
        const a = document.createElement('a');
        a.href = url;
        a.download = file.name ? file.name : 'signature';
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(url);
      } else {
        const id = file;

        const response = await axios.get(`${MasterGraph}/api/FileUpload/DownloadFile/${id}`, {
          ...config,
          responseType: 'blob'
        });
        const url = URL.createObjectURL(response.data);
        const a = document.createElement('a');
        a.href = url;
        a.download = file?.name ? file.name : 'signature';
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(url);
      }

    } catch (error) {
      console.error('Error downloading file:', error);
    }

  };

  useEffect(() => {
    if (workOrderId) {
      fetchFormData();
    }
  }, [isSignatureAffected]);

  const handleSignatureAddRow = () => {
    const id =
      signatureRows.length > 0
        ? Math.max(...signatureRows.map((row) => (isNaN(row.id) ? 0 : Number(row.id)))) + 1
        : 1;
    const newRow = {
      id: id,
      category: '',
      fileType: '',
      designation: '',
      size: '',
    };
    setSignatureRows((oldRows) => [...oldRows, newRow]);
  };

  const handleSignatureUpload = (id) => {
    setSelectedRowId(id);
    setsignatureDialog(true);
  };

  const handleSignatureCloseDialog = () => {
    setsignatureDialog(false);
  };

  const handleSignatureDeleteClick = (id) => () => {
    if (typeof id === 'string') {
      setSignatureId(id);
      setSignatureDeleteDialog(true);
    } else if (typeof id === 'number') {
      if (signatureRows.length > 1 || signatureRows?.[0]?.fileType !== '') {
        const updatedRows = signatureRows.filter((row) => row?.id !== id);
        setSignatureRows(updatedRows);
      }
    }
  };

  const handleConfirmSignatureDeleteClick = async () => {
    const fetchedFiles = getByIdSignatures?.find((item) => item?.id === signatureId);
    if (getByIdSignatures.length > 0 && fetchedFiles) {
      try {
        const completionCategoryFieldName = categoryType === "Scheduled" ? "schcompletionsignatures" : "unschcompletionsignatures";
        const response = await axios.delete(`${checkGraph}/api/${serviceType}routineinspectcompletionsignatures/${signatureId}`, config);
        if (response) {
          setIsSignatureAffected(true);
          fetchFormData();
        }
      } catch (error) {
        console.log("Error deleting item:", error);
      }
    } else {
      const updatedRows = signatureRows.filter((row) => row?.id !== signatureId);
      setSignatureRows(updatedRows);
    }
    setSignatureDeleteDialog(false);
  };

  const handleSignatureDeleteDialogClose = () => {
    setSignatureDeleteDialog(false);
  };

  const handleOnChange = (value, rowId) => {
    const rowIndex = rows?.findIndex(row => row?.id === rowId);

    if (rowIndex === -1) {
      return;
    };

    setDropDownValue(prev => ({
      ...prev,
      [rowId]: value,
    }));

    setDropdownError((prevErrors) => ({
      ...prevErrors,
      [rowId]: false,
    }));
    setDropDownErrorMessage((prevMessages) => ({
      ...prevMessages,
      [rowId]: '',
    }));

    const allowedImageTypes = ['jpeg', 'jpg', 'png'];

    // Check if the selected id is 1 or 2 and validate document type
    if ((value?.id === 1 || value?.id === 2) && rows[rowIndex]?.documenttype) {
      const documentType = rows[rowIndex]?.documenttype?.toLowerCase();

      if (!allowedImageTypes?.includes(documentType)) {
        setError(true);
        setErrorMessage('Error: Only JPEG, JPG, and PNG files are allowed for this selection.');
        setDropDownValue(prev => ({
          ...prev,
          [rowId]: {id:3,label:"Others"},
        }));
      };
    };
  };


  const formatDate = (dateString) => {
    if (!dateString) {
      return '';
    }
  
    try {
      let date;
      date = parseISO(dateString);

      if (!isValid(date)) {
        date = new Date(dateString);
      }

      if (!isValid(date)) {
        return 'Invalid Date';
      }

      const formattedDate = format(date, 'dd/MM/yyyy');
      return formattedDate;
  
    } catch (error) {
      console.error('Error parsing date:', error.message);
    }
  };


  const columns = [
    {
      field: 'signature',
      headerName: 'Signature',
      minWidth: 200,
      minWidth: 150,
      cellRenderer: (params) => (
        <Button 
          variant="outlined" 
          component="label" 
          onClick={() => handleSignatureUpload(params.data.id)}
          size="small"
          sx={{
            width: '100px',
            height: '38px',
            padding: '4px 8px',
            fontSize: '0.75rem',
            display: 'flex',
            justifyContent: 'center',
          }}
          disabled={locationState?.isViewMode || ((params?.data?.file?.type || params?.data?.fileType) ? true : false)}
        >
          {(params?.data?.file?.type || params?.data?.fileType) ? 'Uploaded' : 'Upload'}
        </Button>
      ),
    },
    { field: 'name', headerName: 'Name', width: 150, editable: true },
    { field: 'designation', headerName: 'Designation', width: 150, editable: true },
    { field: 'fileType', headerName: 'File Type', width: 150, editable: true },
    { field: 'size', headerName: 'Size', width: 130, editable: true },
    { field: 'date', headerName: 'Date', width: 130, editable: true,valueGetter: (params) => formatDate(params?.data?.date)},
    {
      field: 'actions',
      headerName: 'Actions',
      minWidth: 160,
      cellRenderer: (params) => (
        <>
         <CustomTooltip title="Delete">
          <Button onClick={handleSignatureDeleteClick(params?.data?.id)} disabled= {isViewMode || (signatureRows?.length === 1 && params?.data?.id && !params?.data?.fileType) ? true : false  }>
            <DeleteIcon />
          </Button>
         </CustomTooltip>
          <CustomTooltip title="Download">
          <Button onClick={() => handleSignatureDownload(params?.data?.filename)} >
            {params?.data?.filename ? <DownloadIcon /> : <></>}
          </Button>
          </CustomTooltip>
        </>
      ),
    }
  ];

  const handleCloseDialog = () => {
    setOpenAlertDialog(false);
  };


  const handleConfirmationDialog = () => {
    if (!locationState?.bottomButtons) {
      setEnableAuthorize(true);
    };
    setOpenAlertDialog(false);
    setEnableAuthorize(true);
    riRepository.workorderStatusValue(serviceType, workOrderId, 9, 92);
    // navigate(location?.pathname, {
    //   state: {
    //       ...location.state,
    //       updateWorkorderstatus:9
    //   }
    // });
    dispatch(routineInspectionCheckFormSubmitForVendor("UPDATE_FORMSUBMIT_STATUS", statusList?.completedOutsource?.id));

  };

  const handleCloseFormSubmitDialog = () => {
    setFormSubmitDialog(false);
  };

  const handleOpenFormSubmitdialog = () => {
    let hasError = false;

     // Check if rows length is greater than 1 and there are meaningful rows
      const attachmentsRows = rows?.filter(row => row?.documenttitle || row?.file || row?.documenttype || row?.filesize);
      const getSignatureRows = signatureRows?.filter(row => row?.designation || row?.fileType || row?.size);

      if (attachmentsRows?.length < 1 ) {
              hasError = true;
              setAttachmentMandatory(true);
           }
      if(getSignatureRows?.length < 1){
        hasError = true;
        setSigantureMandatory(true);
      }
      
    rows.forEach((row) => {
      const rowId = row?.id;
      const value = dropDownValue[rowId];

      // If value is empty and documenttitle exists, trigger an error
      if ((!value || value === "") && row?.documenttitle) {
        hasError = true;

        // Set error state for this row
        setDropdownError((prev) => ({
          ...prev,
          [rowId]: true,
        }));

        setDropDownErrorMessage((prev) => ({
          ...prev,
          [rowId]: "This field is required",
        }));
      } else {
        // Clear error state for this row if it is valid
        setDropdownError((prev) => ({
          ...prev,
          [rowId]: false,
        }));

        setDropDownErrorMessage((prev) => ({
          ...prev,
          [rowId]: "",  // Clear error message
        }));
      }
    });

    // Stop submission if there are errors
    if (hasError) {
      return;
    };
    setFormSubmitDialog(true);
  };

  const handleSnackbarClose = () => {
    setError(false);
  };

  const handleCloseSaveDialog = () => {
    setOpenSaveDialog(false);
  };

  const handleopenAuthorizeDialog = () => {
    setOpenAlertDialog(true);
  };

  const handleConfirmSave = async (event) => {
    event.preventDefault();
    setOpenSaveDialog(false);
    dispatch(routineInspectionClearWebForm("ROUTINEINSPECTION_CLEAR_WEB_FORM", {}));
    // setEnableAuthorize(location?.state?.updateWorkorderstatus === 4 ? true : false); //4 indicates the status ID for completed status
    setEnableAuthorize(getStatus !== 3 && getStatus !== 10 && getStatus !==2 ? true : false); //4 indicates the status ID for completed status
  };

  return (
    <>
      <Box  >
        <form style={{ position: 'relative' }} >
          <Stack direction="row" spacing={1.5} alignItems="center" justifyContent="space-between">
            <Typography variant="h5" gutterBottom>Attachments</Typography>
            <Box sx={{ flexGrow: 1 }} />
            {!(locationState?.isViewMode) && <AddRowButton onClick={handleAddRow} />}
          </Stack>
          {attachmentMandatory && (<Typography component={"span"} color={"error"}>
                                                {"Please add at least one Attachment."}*
                                            </Typography>)}
          <Box mb={2} />
          <CustomAgGrid
            rows={rows}
            columns={[
              {
                field: 'attachmentType',
                headerName: 'Image Type',
                minWidth: 200,
                cellRenderer: (params) => {
                  const rowId = params?.data?.id || "";
                  const selectedOption = dropDownValue[rowId] || { id: 3, label: "Others" };
                  const currentId = selectedOption?.id || params?.data?.attachmentType || "";
                  const currentOption = attachmentTypeOptions.find(option => option?.id === currentId);
                  const currentLabel = selectedOption?.label || currentOption?.label || '';
                  const OptionsValue = selectedOption?.id ? selectedOption : { id: currentId, label: currentLabel };
                  const disablefield = params?.data?.filename ? true : false;

                  return (
                    <div>
                      <CustomSelectInput
                        error={dropdownError[rowId]}
                        errorMessage={dropDownErrorMessage[rowId]}
                        name="isBefore"
                        value={OptionsValue || ""}
                        options={attachmentTypeOptions || []}
                        onChange={(value) => handleOnChange(value, rowId)}
                        disabled={disablefield || locationState?.isViewMode}
                      />
                    </div>
                  );
                },
              },
              {
                field: 'file',
                headerName: 'File',
                flex: 1,
                cellRenderer: (params) => (
                  <Button 
                    variant="outlined" 
                    component="label"
                    size="small"
                    disabled={params.data?.documenttitle || locationState?.isViewMode}
                    sx={{
                      width: '100px',
                      height: '38px',
                      padding: '4px 8px',
                      fontSize: '0.75rem',
                      display: 'flex',
                      justifyContent: 'center',
                    }}
                  >
                    {params.data.documenttitle ? 'Uploaded' : 'Upload'}
                    <input
                      type="file"
                      hidden
                      onChange={(event) => handleFileChange(event, params?.data?.id)}
                    />
                  </Button>
                ),
              },
              {
                field: 'documenttitle',
                headerName: 'File Name',
                flex: 1,
              },
              {
                field: 'documenttype',
                headerName: 'File Type',
                flex: 1,
              },
              {
                field: 'filesize',
                headerName: 'Size',
                flex: 1,
              },
              {
                field: 'actions',
                type: 'actions',
                headerName: 'Actions',
                flex: 1,
                minWidth: 160,
                cellClassName: 'actions',
                cellRenderer: (params) => (
                  <>
                  <CustomTooltip title="Delete">
                    <Button onClick={handleDeleteClick(params?.data?.id)} disabled = { isViewMode || (rows?.length === 1 && params?.data?.id && !params?.data?.documenttitle) ? true : false}>
                      <DeleteIcon />
                    </Button>
                  </CustomTooltip>
                    <CustomTooltip title="Download">
                      <Button onClick={(event) => handleDownloadClick(event, params?.data)} >
                        {params?.data?.filename ? <DownloadIcon /> : <></>}
                      </Button>
                    </CustomTooltip>
                  </>
                ),
              },
            ]}
            setGridApi={setGridApi}
          />

          <Box mt={{ xs: 1, md: 2 }} sx={{ marginTop: '0rem' }}>
            <Stack direction="row" spacing={1.5} alignItems="center" justifyContent="space-between" mb={2}>
              <Grid >
                <Typography variant="title2" align="left">Add Signature</Typography>
                <Box mb={2} />
                <Typography variant="body2" >
                  {/* Please add files in format of doc, jpg, png, pdf. */}
                </Typography>
              </Grid>
              {!(isViewMode) && <Grid sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <AddRowButton onClick={handleSignatureAddRow} />
              </Grid>}
            </Stack>
            {sigantureMandatory && (<Typography component={"span"} color={"error"}>
                                      {"Please add at least one Signature."}*
                                  </Typography>)}
            <CustomAgGrid
              rows={signatureRows}
              columns={columns}
              setGridApi={setGridApi}
            />

            <Dialog open={signatureDialog} onClose={(event, reason) => {
              if (reason !== 'backdropClick') {
                handleSignatureCloseDialog();
              }
            }} >
              <DialogContent>
                <RoutineInspectionSignatureGrid
                  onCancel={handleSignatureCloseDialog}
                  onClear={handleSignatureCloseDialog}
                  onSave={(data) => handleSaveSignature(selectedRowId, data)}
                  rowData={signatureRows.find((row) => row.id === selectedRowId)}
                  locationState={{ workorderId: workOrderId, serviceType: assetCategroyType, categoryType: categoryType }}
                />
              </DialogContent>
            </Dialog>
          </Box>
          <Box>
            {locationState?.bottomButtons && <BottomButtonForVendor page={page} buttonAttributes={buttonAttributes} authorizeButton={true} authorizeClick={handleopenAuthorizeDialog} enableAuthorizeButton={enableAuthorize} saveButton={true} saveClick={handleOpenFormSubmitdialog} disableSave={isViewMode}  />}
            {!locationState?.bottomButtons && <RoutineInspectionBottomButtonForVendorForm page={page} buttonAttributes={buttonAttributes} authorizeButton={true} authorizeClick={handleopenAuthorizeDialog} saveButton={true} saveClick={handleOpenFormSubmitdialog} enableAuthorizeButton={enableAuthorize} disableSave={isViewMode} />}
          </Box>

        </form>

      </Box>

      <CustomDialog
        open={deleteDialogOpen}
        onClose={handleDeleteDialogClose}
        title="Confirm Delete"
        content="Are you sure you want to delete?"
        confirmBtn="Yes"
        cancelBtn="No"
        onConfirm={handleDeleteConfirm}
        onCancel={handleDeleteDialogClose}
      />

      <CustomDialog
        open={signatureDeleteDialog}
        onClose={handleSignatureDeleteDialogClose}
        title="Confirm Delete"
        content="Are you sure you want to delete?"
        confirmBtn="Yes"
        cancelBtn="No"
        onConfirm={handleConfirmSignatureDeleteClick}
        onCancel={handleSignatureDeleteDialogClose}
      />
      <CustomDialog
        open={error}
        onClose={handleSnackbarClose}
        content={errorMessage}
        confirmBtn="OK"
        onConfirm={() => setError(false)}
      />

      <CustomDialog
        open={formSubmitDialog}
        onClose={handleCloseFormSubmitDialog}
        content="Are you sure you want to Save?"
        confirmBtn="Yes"
        cancelBtn="No"
        onConfirm={handleSaveClick}
        onCancel={handleCloseFormSubmitDialog}
      />

      <CustomAlert
        open={openAlertDialog}
        onClose={handleCloseDialog}
        onConfirm={handleConfirmationDialog}
        content={`${workOrderNo || ""} has been Submitted Successfully.`}
        confirmBtn='OK'
      />

      <CustomAlert
        open={openSaveDialog}
        onClose={handleCloseSaveDialog}
        onConfirm={handleConfirmSave}
        content={`${workOrderNo || ""} has been Saved Successfully.`}
        confirmBtn='OK'
      />
    </>
  );
};

export default RoutineInspectionAttachmentsEditForm;
